import { API_BASE_URL } from "../config/config";
import axios from "axios";
import Cookies from "js-cookie";

const TxFindToken = async (uid) => {
    //ask txshield to get the token for the user
    let options = { headers: { Authorization: "Bearer " + Cookies.get("access_token") } };
    const data = await axios
        .get(API_BASE_URL + "/v3/user/" + uid + "/gettxfindtoken", options)
        .then(({ data }) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
            return false;
        });
    return data;
};
export default TxFindToken;